// Brillenhaus – Warenkorb: "Passt dazu"-Produkte per Klick hinzufügen. Das Theme rendert den Warenkorb
// danach über das CartAddEvent neu (Summe, Versand-Balken, Empfehlungen).
import { CartAddEvent } from '@theme/events';

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bh-cart-add]');
  if (!button || button.disabled) return;
  event.preventDefault();
  button.disabled = true;
  button.classList.add('is-loading');
  const root = window.Shopify?.routes?.root || '/';
  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.bhCartAdd), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    const cart = await fetch(`${root}cart.js`).then((r) => r.json());
    document.dispatchEvent(
      new CartAddEvent(cart, 'bh-warenkorb', { source: 'bh-warenkorb', itemCount: cart.item_count, variantId: button.dataset.bhCartAdd })
    );
  } catch {
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});
